module.exports = __webpack_public_path__ + "media/question2_au.b6211f81.mp3";